import 'css-chunk:src/app/components/ColorPicker/ColorPicker.scss';export default {
  "ColorPicker": "_ColorPicker_1r5zj_1",
  "swatch": "_swatch_1r5zj_5",
  "value": "_value_1r5zj_15",
  "ColorPicker__disabled": "_ColorPicker__disabled_1r5zj_25",
  "Popover": "_Popover_1r5zj_31"
};